module.exports = __webpack_public_path__ + "static/uswithsarah-f64e933d94bb885fc4c2d8f3a3768ea7.jpg";